import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getLlantasProData } from "../../modules/llantasPro";
import { changeTitle } from "./../../modules/navigation";
import LlantasProView from "./LlantasProView";
import hasTP from "./../../utilities/unitsFilters";
import { DOMAIN } from "../../utilities/consts";

class LlantasPro extends Component {
  componentDidMount() {
    this.props.changeTitle("LlantasPro");
  }

  downloadExcel = () => {};

  fetchLlantasProData = () => {
    this.props
      .getLlantasProData()
      .then(() => {
        console.log("data loaded");
      })
      .catch(() => {
        console.log("request failed");
      });
  };

  downloadExcel = () => {};

  downloadPDF = () => {};

  render() {
    return (
      <LlantasProView
        downloadExcel={this.downloadExcel}
        downloadPDF={this.downloadPDF}
        fetchLlantasProData={this.fetchLlantasProData}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => {
  let lang = state.internationalization.lang;
  let behavior = {};
  let events = [];
  let analysisByUnit = [];
  if (state.llantasPro.hasData) {
    behavior = state.llantasPro.data.ReporteGeneral.Comportamiento;
  }

  return {
    lang,
    isLoading: state.llantasPro.isLoading,
    hasData: state.llantasPro.hasData,
    distanceUnit: state.llantasPro.data.UnidadVelocidad,
    units: state.units.data.filter(v => hasTP(v, [""])),
    permissions: state.permissions.data,
    loadedPermissions: state.permissions.loadedPermissions,
    individualReport: state.units.selectedUnits.length <= 1, //state.fuel.data.Unidades.length <= 1, // prueba
    behavior,
    events,
    analysisByUnit
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changeTitle,
      getLlantasProData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LlantasPro);



// WEBPACK FOOTER //
// ./src/containers/LlantasPro/LlantasPro.js